import type { FaireProductEntity } from "../../entity_types/product";

export const p_qdjefzv8vk: FaireProductEntity = {
  token: "p_qdjefzv8vk",
  type: "product",
  name: "3 pc Orbicular ocean jasper fluorite Snake F977",
  brandToken: "b_yrt8x5m6m6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2e297b8072cc003f14903cf0c2354b6a1875ba1f5bf2b3e70e64f5481fd49483.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/deb18c77d794e90872938ece432c77929c174abfb47bf346da1bc5b9de54b53f.jpeg",
    "https://cdn.faire.com/fastly/d79212cb59eb9aa4aa4bcb01ba0b871eac62288d270e09211810f866fc689210.jpeg",
    "https://cdn.faire.com/fastly/207b1791d17391553903108b4bbd4e0cd415b3cb18759b9583995b8972e79b10.jpeg",
    "https://cdn.faire.com/fastly/2391a3945d78aa27c7e3aa5e216abb641a2a1074ca17c42270f06e43661035b1.jpeg",
    "https://cdn.faire.com/fastly/7c5f73dab4b483b729a204105e5756a1da447691348ed86458dee281412b20ac.jpeg",
    "https://cdn.faire.com/fastly/18aec696b67d3c164e6eefe61049c2907bd5d7f13687f54d7c080a38a0a560eb.jpeg",
  ],
  priceDollars: 149.66,
  description:
    '3 pc Orbicular ocean jasper fluorite sky blue quartz F977\n\nEach comes with (3) crystal-meaning cards\nThis is the exact set you will receive\n\nSky blue 5.9" x 4" x 1.6"\nOrbicular ocean jasper 5.7"\nFluorite 4.5"',
  tags: [],
  msrpDollars: 299.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:19.855Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
